export interface SocialLink {
  id: string;
  label: string;
  href: string;
}

/** Update handles when official MyLighthouse social profiles are live. */
export const LIGHTHOUSE_SOCIAL_LINKS: SocialLink[] = [
  {
    id: 'x',
    label: 'MyLighthouse on X',
    href: 'https://x.com/lighthouse_ng',
  },
  {
    id: 'instagram',
    label: 'MyLighthouse on Instagram',
    href: 'https://instagram.com/mylighthouse.ng',
  },
  {
    id: 'linkedin',
    label: 'MyLighthouse on LinkedIn',
    href: 'https://www.linkedin.com/company/lighthouse-ng',
  },
  {
    id: 'facebook',
    label: 'MyLighthouse on Facebook',
    href: 'https://facebook.com/mylighthouse.ng',
  },
];

function SocialIcon({ id }: { id: string }) {
  switch (id) {
    case 'x':
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4" aria-hidden>
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4" aria-hidden>
          <path d="M7.8 2h8.4A5.8 5.8 0 0 1 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8A5.8 5.8 0 0 1 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8A3.6 3.6 0 0 0 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6A3.6 3.6 0 0 0 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25 1.25 1.25 0 0 1-2.5 0 1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
        </svg>
      );
    case 'linkedin':
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4" aria-hidden>
          <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
        </svg>
      );
    case 'facebook':
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4" aria-hidden>
          <path d="M22 12a10 10 0 1 0-11.56 9.87v-6.98H8.1v-2.89h2.34V9.41c0-2.31 1.38-3.59 3.49-3.59.99 0 2.03.18 2.03.18v2.24h-1.14c-1.13 0-1.48.7-1.48 1.42v1.7h2.52l-.4 2.89h-2.12v6.98A10 10 0 0 0 22 12z" />
        </svg>
      );
    default:
      return null;
  }
}

export function FooterSocialLinks() {
  return (
    <div className="footer-social">
      <p className="footer-social-label">Follow us</p>
      <div className="footer-social-row">
        {LIGHTHOUSE_SOCIAL_LINKS.map((link) => (
          <a
            key={link.id}
            href={link.href}
            className="footer-social-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={link.label}
          >
            <SocialIcon id={link.id} />
          </a>
        ))}
      </div>
    </div>
  );
}
